import React from 'react';
import Skeleton, { SkeletonGroup, SkeletonText } from '../../components/common/Skeleton';
import './CompetitionPage.css';

/** The competition page's outline (header strip, tabs, first card) while it loads. */
const CompetitionPageSkeleton: React.FC = () => (
  <SkeletonGroup label="Loading competition" className="competition-page">
    <div className="competition-strip">
      <div className="competition-strip__top">
        <Skeleton radius={10} className="competition-skeleton__logo" />
        <div className="competition-strip__title competition-skeleton__title">
          <Skeleton width="55%" height="2rem" />
          <Skeleton width="30%" height="1rem" />
          <div className="competition-skeleton__pills">
            {[64, 56, 80, 72].map((w) => <Skeleton key={w} width={w} height={24} radius={999} />)}
          </div>
        </div>
      </div>
    </div>
    <div className="competition-skeleton__tabs">
      {[92, 72, 108].map((w) => <Skeleton key={w} width={w} height={36} radius={8} />)}
    </div>
    <div className="competition-skeleton__body">
      <Skeleton width="25%" height="1.4rem" />
      <SkeletonText lines={5} />
    </div>
  </SkeletonGroup>
);

export default CompetitionPageSkeleton;
